import React from "react";
import { dispatch } from '@rematch/core';

import { Button, Popup } from 'semantic-ui-react'

import _ from 'lodash'

import Overview from "./../../../../../images/svg/initiative_svg/icon-i-overview.svg";
import AdditionalInfo from "./../../../../../images/svg/initiative_svg/additional_info.svg";
import Progress from "./../../../../../images/svg/initiative_svg/icon-i-progress.svg";
import Sequence from "./../../../../../images/svg/initiative_svg/icon-i-sequence.svg";
import Teams from "./../../../../../images/svg/initiative_svg/icon-i-teams.svg";
import Timeline from "./../../../../../images/svg/initiative_svg/icon-i-timeline.svg";



let icon = {
    Overview: Overview,
    Progress: Progress,
    Sequence: Sequence,
    Teams: Teams,
    Timeline: Timeline,
    AdditionalInfo: AdditionalInfo
}

const style = {
    borderRadius: 0,
    opacity: 0.8,
    padding: '6px'
}


class ArrangementPane extends React.Component {
    constructor(props) {
        super(props);
        this.redirectTo = this.redirectTo.bind(this);
    }

    redirectTo(item) {

        this.props.advancedFilterProperties.roles = [];
        this.props.advancedFilterProperties.stateActiveChecked = false;
        this.props.advancedFilterProperties.stateOnHoldChecked = false;
        this.props.advancedFilterProperties.statusNotStartedChecked = false;
        this.props.advancedFilterProperties.statusCompletedChecked = false;
        this.props.advancedFilterProperties.statusIssueChecked = false;
        this.props.advancedFilterProperties.statusInProgressChecked = false;
        this.props.advancedFilterProperties.statusDelayedChecked = false;
        this.props.advancedFilterProperties.showAllRoles = false;
        this.props.advancedFilterProperties.serarchedRolesAvailable = false;
        this.props.advancedFilterProperties.searchedRoles = [];
        this.props.advancedFilterProperties.value = '';
        this.props.advancedFilterProperties.userSearchValue = '';
        this.props.advancedFilterProperties.selectedUsers = [];
        this.props.advancedFilterProperties.serarchedUsersAvailable = false;
        dispatch.initiatives.setAdvancedFilterProperties(Object.assign({}, this.props.advancedFilterProperties));

        this.props.raciFilterProperties.raciAllChecked = true;
        this.props.raciFilterProperties.accountable = false;
        this.props.raciFilterProperties.responsible = false;
        this.props.raciFilterProperties.consulted = false;
        this.props.raciFilterProperties.informed = false;
        dispatch.initiatives.setRACIFilterProperties(Object.assign({}, this.props.raciFilterProperties));

        let payload = {
            initiativeId: this.props.selectedDataById._id
        }
        if (item.name === 'Progress') {
            payload.accountUserId = this.props.user._id;
            // dispatch.initiatives.getAllActivities(payload);
        }

        if (item.name === 'Sequence') {
            // dispatch.initiatives.getActiveInitiativeDetailsById(payload.initiativeId);
        }

        if (item.name === 'Teams') {
            // dispatch.initiatives.getCommunityWiseActivities(payload.initiativeId);
        }
        dispatch.app.setCollapsedResourcePaneIndexTemp(null)
        dispatch.initiatives.showResourecePane(null);

        dispatch.initiatives.setSelectedActivityData({});
        dispatch.initiatives.splitAt("60%")
        const { history } = this.props;
        let pathname = `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_in/start/active/${item.name}/${this.props.selectedDataById._id}`
        history.push({ pathname: pathname });

    }

    redirectToList() {
        const { history } = this.props;
        let pathname = `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_in`
        history.push({ pathname: pathname });
        dispatch.initiatives.showResourecePane(null)
    }

    mouseEnter(name) {
        dispatch.app.setHelpContext(name);
    }


    render() {

        const buttonMenu = [
            { name: "Progress", text: "Progress", icon: "th large", status: 0 },
            { name: "AdditionalInfo", text: "Custom Attribute", icon: "group", status: 4 },
            { name: "Sequence", text: "Sequence", icon: "th list", status: 1 },
            { name: "Teams", text: "Teams", icon: "sitemap", status: 2 },
            { name: "Timeline", text: "Timeline", icon: "group", status: 3 },
        ]
        const overview = { name: "Overview", icon: "th large", status: 5 }
        return (
            <div className="arrangementPane" style={{ height: (this.props.componentDesignerDimension.windowHeight - 50) - this.props.componentDesignerDimension.height }}>
                <Button.Group vertical>
                    <Popup
                        trigger={<Button
                            onMouseEnter={() => this.mouseEnter(overview.name)}
                            className={this.props.activeTab === "ActiveInitiative" ? "button active" : "button"}
                            onClick={(e) => { this.redirectToList() }}>
                            <img src={icon.Overview} alt="Overview Icon" /></Button>}
                        content={overview.name}
                        position='left center'
                        style={style}
                        inverted
                    />
                    {buttonMenu
                        .filter((f, index) => {
                            return (this.props.selectedDataById.status === -1 && f.status === 4) ||
                                this.props.selectedDataById.status !== -1 && (f.status !== 4 || (f.status === 4 && !_.isEmpty(this.props.selectedDataById.metaData)))
                        })
                        .map((item, index) => {

                            // return item.status !== 4 || (item.status === 4 && (this.props.selectedDataById.status === -1 || )) ? <Popup
                            return <Popup
                                key={index}
                                trigger={<Button
                                    key={index}
                                    onMouseEnter={() => this.mouseEnter(item.name)}
                                    className={this.props.activeTab === item.name ? "button active" : "button"}
                                    onClick={(e) => { this.redirectTo(item) }}
                                >
                                    <img alt="Action Icon"
                                        src={
                                            item.status === 0 ? icon.Progress :
                                                item.status === 1 ? icon.Sequence :
                                                    item.status === 2 ? icon.Teams :
                                                        item.status === 3 ? icon.Timeline :
                                                            item.status === 4 ? icon.AdditionalInfo : ""}
                                    /></Button>}
                                content={item.text}
                                position='left center'
                                style={style}
                                inverted
                            />
                        })}


                </Button.Group>
            </div>
        );
    }
}
export default ArrangementPane;
